module.exports = __webpack_public_path__ + "static/media/technogy2.8f1195e4.png";